import type { Locale } from './types.js';

export const LOCALE_STORAGE_KEY = 'kit-locale';

export function resolveInitialLocale(savedLocale: string | null, browserLanguage: string): Locale {
  if (savedLocale === 'en' || savedLocale === 'zh-CN') return savedLocale;
  return browserLanguage.toLowerCase().startsWith('zh') ? 'zh-CN' : 'en';
}

export function pageTitle(path: string, locale: Locale): string {
  const labels: Record<string, [string, string]> = {
    '/auth/login': ['Sign in', '登录'],
    '/auth/register': ['Create account', '创建账号'],
    '/auth/verify': ['Verify email', '验证邮箱'],
    '/auth/verify-login': ['Verify sign-in', '验证登录'],
    '/auth/forgot': ['Recover account', '找回账号'],
    '/auth/reset': ['Reset password', '重置密码'],
    '/auth/invite': ['Accept invitation', '接受邀请'],
    '/app': ['Workspace home', '工作空间首页'],
    '/app/codes': ['QR codes', '二维码'],
    '/app/codes/new': ['Create QR code', '创建二维码'],
    '/app/forms': ['Forms', '表单'],
    '/app/forms/new': ['Create form', '创建表单'],
    '/app/data': ['Data', '数据'],
    '/app/data/submissions': ['Submissions', '提交记录'],
    '/app/data/incidents': ['Incidents', '异常工单'],
    '/app/data/by-qr': ['QR activity', '二维码汇总'],
    '/app/settings': ['Settings', '设置'],
    '/app/settings/billing': ['Billing and plan', '账单与套餐'],
    '/app/settings/notifications': ['Submission email notifications', '提交邮件通知'],
  };
  const normalized = path === '/app/' ? '/app' : path;
  const direct = labels[normalized];
  const label = direct
    ?? (/^\/app\/codes\/[0-9a-f-]{36}$/u.test(normalized) ? ['Edit QR code', '编辑二维码'] as const : undefined)
    ?? (/^\/app\/forms\/[0-9a-f-]{36}$/u.test(normalized) ? ['Edit form', '编辑表单'] as const : undefined)
    ?? (/^\/app\/data\/submissions\/[0-9a-f-]{36}$/u.test(normalized) ? ['Submission detail', '提交记录详情'] as const : undefined)
    ?? ['QR Workspace', '二维码工作空间'] as const;
  return `${locale === 'zh-CN' ? label[1] : label[0]} | 321Kit`;
}
